import { Button, Col, Form, Input, Row } from "antd";
import React, { useState } from "react";
import { LogisticsIems } from "../../services/items";
import { v4 as uuid } from "uuid";
import { useApiContext } from "../../hooks/useApiContext";
import { PlusCircleOutlined } from "@ant-design/icons";

export default function LogisticsSupportForm() {
  const { logisticsItemdispatch } = useApiContext();
  const [logisticsitemForm] = Form.useForm();
  const [itemDescription, setItemDescription] = useState("");
  const [itemQuantity, setItemQuantity] = useState("");
  const [itemCompany, setItemCompany] = useState("");
  const [itemRemarks, setItemRemarks] = useState("");


  const addLogisticsItemSubmit = () => {
    let newValues = {
      id: uuid(),
      description: itemDescription,
      quantity: itemQuantity,
      companyName: itemCompany,
      remarks: itemRemarks,
    };
    LogisticsIems.add(logisticsItemdispatch, newValues);
    logisticsitemForm.resetFields();
    console.log("Damand items", newValues);
  };
  return (
    <Form
      form={logisticsitemForm}
      layout="vertical"
      name="horizontal_login"
      style={{ width: "100%" }}
    >
      <Col span={24}>
        <Row>
          <Col span={6}>
            <Form.Item
              name="description"
              rules={[{ required: true, message: "Please Enter description" }]}
              label="Description"
            >
              <Input
                placeholder="Description"
                onChange={(e) => setItemDescription(e.target.value)}
              />
            </Form.Item>
        
          </Col>
          <br/>
          <Col span={6}>
          <Form.Item
              name="RATE OF PER HOUR/MONTH"
              rules={[{ required: true, message: "Please enter your RATE OF PER HOUR/MONTH" }]}
              label="RATE OF PER HOUR/MONTH"
            >
              <Input
                onChange={(e) => setItemRemarks(e.target.value)}
                placeholder="RATE OF PER HOUR/MONTH"
              />
            </Form.Item>
          </Col>
     
          <Col span={3} offset={1}>
            <Form.Item label="">
              <Button
                style={{ marginTop: "32px" }}
                type="primary"
                icon={<PlusCircleOutlined />}
                onClick={addLogisticsItemSubmit}
              >
                Add Item
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Col>
    </Form>
  );
}
